export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to spend every Sunday night building sequences from scratch. Now I open the Vault, pick the class that fits the group and I’m done in ten minutes. My evenings are mine again.',
    author: 'Hannah P.',
    role: 'Yoga Teacher',
    location: 'Bristol, UK',
  },
  {
    quote:
      'The mixed-level and chair classes saved me. I teach three community groups a week and I always have something ready — even when the room turns out completely different from what I expected.',
    author: 'Marisol G.',
    role: 'Yoga Instructor',
    location: 'Austin, Texas',
  },
  {
    quote:
      'The cueing library changed how I speak in class. I stopped repeating the same five sentences and my students actually understand what I’m asking for now.',
    author: 'Chloe D.',
    role: 'Yoga Teacher',
    location: 'Melbourne, Australia',
  },
]
